<template>
	<!--主子表-->
	<!-- @cell-click="cellclick" -->
	<pl-table
		style="width:99%;"
		ref="tablegrid"
		:class="isCopyRange?`select-table`:``" 
		@sort-change="gridsortchange"
		:height="height"
		:data="tableData"
		selectTrClass="selectTr"
		:dataChangesScrollTop="istop"
		fixedColumnsRoll
		bigDataCheckbox
		:excess-rows="5"
		:stripe="stripe"
		:highlight-current-row="false"
		inverse-current-row
		header-align="center"
		use-virtual
		:row-height="48"
		:row-class-name="rowclassname"
		@table-body-scroll="gridscroll"
		@selection-change="handleSelectionChange"
		@select="onTableSelect"
		@select-all="selectall"
		@row-dblclick="rowdblclick"
		:cell-class-name="cellclassname"
		:header-cell-style="{ background: '#f5f5f5', color: '#606266', textAlign: 'center', paddingTop: '8px', paddingBottom: '8px' }"
		:cell-style="{ padding: '0px',height:'40px' }"
	>
		<template slot="empty">
			{{emptytext}}
		</template>
		<pl-table-column type="selection" width="55" fixed v-for="(c, index) in columns" v-if="c.field == 'checkbox'" :key="index" />
		<pl-table-column type="index" width="50" fixed label="序号" v-if="isseq=='1'" />
		<!-- && c.type != 'checkbox' -->
		<pl-table-column
			v-for="(c, index) in columns"
			v-if="c.type != 'template' && c.type != '' && c.colshow != 0"
			:key="index"
			:show-overflow-tooltip="true"
			:label="c.title"
			:min-width="c.width + '%'"
			:sortable="c.sortable"
			:align="c.align"
			:prop="c.field"
		>
			<template slot-scope="scope">
				<span v-if="c.type == 'text'">{{ scope.row[c.field] }}</span>
				<!-- <span v-if="c.type == 'switch'">{{ scope.row[c.field] }}</span> 		:active-value="1"
					:inactive-value="0"-->
				<el-checkbox
					:ref="c.type + '_' + index + '_' + scope.$index"
					v-if="c.type == 'checkbox'"
					@focus="setoldvalue(scope.row)"
					v-model="scope.row[c.field]"
					:disabled="true"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
				></el-checkbox>
				<el-switch
					:ref="c.type + '_' + index + '_' + scope.$index"
					v-if="c.type == 'switch_default'"
					@focus="setoldvalue(scope.row)"
					:disabled="scope.row.isedit"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					:active-value="true"
					:inactive-value="false"
				></el-switch>
				<div v-if="scope.row[c.field] == '否'">
					<el-switch
						:ref="c.type + '_' + index + '_' + scope.$index"
						v-if="c.type == 'switch'"
						@focus="setoldvalue(scope.row)"
						@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
						v-model="scope.row[c.field]"
						active-value="是"
						inactive-value="否"
					></el-switch>
				</div>
				<div v-if="scope.row[c.field] == '是'">
					<el-switch
						:ref="c.type + '_' + index + '_' + scope.$index"
						v-if="c.type == 'switch'"
						@focus="setoldvalue(scope.row)"
						@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
						v-model="scope.row[c.field]"
						active-value="是"
						inactive-value="否"
					></el-switch>
				</div>
				<el-select
					:clearable="true"
					v-if="c.type == 'select'"
					:ref="c.type + '_' + index + '_' + scope.$index"
					@focus="setoldvalue(scope.row, c)"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					size="mini"
					filterable
					v-model="scope.row[c.field]"
					:disabled="scope.row.isedit" 
					@keyup.native="event => gridkeyupinput(event, index, scope.$index)"
				>
					<el-option v-for="item in c.source" :key="item.label" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-cascader
					v-if="c.type == 'picker'"
					:ref="c.type + '_' + index + '_' + scope.$index" 
				    v-model="scope.row[c.field]" 
					:show-all-levels="false"
				    :options="c.source"
					:props="{value:'label',label:'label'}"
					size="mini"
					:clearable="true"
				    @change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"></el-cascader>
				<el-select
					:ref="c.type + '_' + index + '_' + scope.$index"
					v-if="c.type == 'select_filter'"
					filterable
					:clearable="true"
					:filter-method="val => selectFilter(val, c)"
					@focus="setoldvalue(scope.row, c)"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					size="mini"
					v-model="scope.row[c.field]"
					:disabled="scope.row.isedit"
					@keyup.native="event => gridkeyupinput(event, index, scope.$index)"
				>
					<el-option v-for="item in c.source" :key="item.label" :label="item.label" :value="item.label"></el-option>
				</el-select>
				<el-input
					:ref="c.type + '_' + index + '_' + scope.$index"
					v-if="c.type == 'input'"
					@focus="setoldvalue(scope.row)"
					@blur="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					size="mini"
					v-model="scope.row[c.field]"
					:disabled="scope.row.isedit"
					@keyup.native="event => gridkeyupinput(event, index, scope.$index)"
				></el-input>
				<el-date-picker
					:ref="c.type + '_' + index + '_' + scope.$index"
					v-if="c.type == 'time'"
					v-model="scope.row[c.field]"
					type="datetime"
					size="mini"
					value-format="yyyy-MM-dd HH:mm:ss"
					@input="settimevalue(scope.$index, scope.row, c.field)"
					@focus="setoldvalue(scope.row)"
					
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					style="width:100%"
					
				></el-date-picker>
				<!--@blur="handle(c.event, scope.$index, scope.row, c.field, 'change', index)" @keyup.native="event => gridkeyupinput(event, index, scope.$index)" -->
				<el-date-picker
					:ref="c.type + '_' + index + '_' + scope.$index"
					v-if="c.type == 'date'"
					v-model="scope.row[c.field]"
					type="date"
					size="mini"
					format="yyyy-MM-dd"
					@input="settimevalue(scope.$index, scope.row, c.field)"
					@focus="setoldvalue(scope.row)"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					style="width:100%"
				></el-date-picker>
				<!--@blur="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"  @keyup.native="event => gridkeyupinput(event, index, scope.$index)" -->
				<div v-if="c.type == 'openurl'">
					<el-tag v-if="scope.row[c.field] != ''" type="primary" disable-transitions @click="openurl(c, scope.row)" style="cursor:pointer;">{{ scope.row[c.field] }}</el-tag>
					<span v-else>{{ scope.row[c.field] }}</span>
				</div>
				<div v-if="c.type == 'getwl'">
					<el-popover v-if="scope.row[c.field] != ''" trigger="click" placement="top" width="350" @show="showevent(scope.row, c, 1)">
						<div style="max-height:320px;overflow-y:auto;padding-left:10px">
							<p style="padding-bottom:10px;cursor:pointer" @click="copyvalue(scope.row[c.field])">单号：{{scope.row[c.field]}}</p>
							<el-timeline>
								<el-timeline-item v-if="index == 0" type="primary" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">
									{{ wl.context }}
								</el-timeline-item>
								<el-timeline-item v-if="index > 0" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">{{ wl.context }}</el-timeline-item>
							</el-timeline>
						</div>
						<div slot="reference" class="name-wrapper">
							<el-tag size="medium">{{ scope.row[c.field] }}</el-tag>
						</div>
					</el-popover>
					<span v-if="scope.row[c.field] == ''">{{ scope.row[c.field] }}</span>
				</div>
				<!-- 查物流不结转订单 -->
				<div v-if="c.type == 'getwl_notrans'">
					<el-popover v-if="scope.row[c.field] != ''" trigger="click" placement="top" width="350" @show="showevent(scope.row, c, 4)">
						<div style="max-height:320px;overflow-y:auto;padding-left:10px">
							<p style="padding-bottom:10px;cursor:pointer" @click="copyvalue(scope.row[c.field])">单号：{{scope.row[c.field]}}</p>
							<el-timeline>
								<el-timeline-item v-if="index == 0" type="primary" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">
									{{ wl.context }}
								</el-timeline-item>
								<el-timeline-item v-if="index > 0" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">{{ wl.context }}</el-timeline-item>
							</el-timeline>
						</div>
						<div slot="reference" class="name-wrapper">
							<el-tag size="medium">{{ scope.row[c.field] }}</el-tag>
						</div>
					</el-popover>
					<span v-if="scope.row[c.field] == ''">{{ scope.row[c.field] }}</span>
				</div>
				<div v-if="c.type == 'getwl_expressid'">
					<el-popover v-if="scope.row[c.field] != ''" trigger="click" placement="top" width="350" @show="showevent(scope.row, c, 2)">
						<div style="max-height:320px;overflow-y:auto;padding-left:10px">
							<p style="padding-bottom:10px;cursor:pointer" @click="copyvalue(scope.row[c.field])">单号：{{scope.row[c.field]}}</p>
							<el-timeline>
								<el-timeline-item v-if="index == 0" type="primary" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">
									{{ wl.context }}
								</el-timeline-item>
								<el-timeline-item v-if="index > 0" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">{{ wl.context }}</el-timeline-item>
							</el-timeline>
						</div>
						<div slot="reference" class="name-wrapper">
							<el-tag size="medium">{{ scope.row[c.field] }}</el-tag>
						</div>
					</el-popover>
					<span v-if="scope.row[c.field] == ''">{{ scope.row[c.field] }}</span>
				</div>
				<div v-if="c.type == 'getwl_airwaybill'">
					<el-popover v-if="scope.row[c.field] != ''" trigger="click" placement="right-start" width="900" @show="showevent(scope.row, c, 3)">
						<div style="max-height:380px;overflow-y:auto;padding-left:10px">
							<p style="padding-bottom:10px;cursor:pointer" @click="copyvalue(scope.row[c.field])">单号：{{scope.row[c.field]}}</p>
							<el-table :data="airtitle" style="width:100%">
								<el-table-column prop="destination" label="出发地"></el-table-column>
								<el-table-column prop="origin" label="目的地"></el-table-column>
								<el-table-column prop="pieces" label="件数" width="80"></el-table-column>
								<el-table-column prop="weight" label="重量" width="80"></el-table-column>
								<el-table-column prop="flight_info" label="航班信息"></el-table-column>
							</el-table>
							<pl-table height="260" :data="airinfo.track">
								<pl-table-column
									v-for="(air, airidx) in aircolumns"
									:key="airidx"
									:show-overflow-tooltip="true"
									:label="air.title"
									align="center"
									:min-width="air.width"
									:prop="air.field"
									:excess-rows="5"
									header-align="center"
									use-virtual
								>
									<template slot-scope="cope">
										<span>{{ cope.row[air.field] }}</span>
									</template>
								</pl-table-column>
							</pl-table>
						</div>
						<div slot="reference" class="name-wrapper">
							<el-tag size="medium">{{ scope.row[c.field] }}</el-tag>
						</div>
					</el-popover>
					<span v-if="scope.row[c.field] == ''">{{ scope.row[c.field] }}</span>
				</div>
				<div v-if="c.type=='input_confirm'">
					<el-popover trigger="click" :ref="`popover-${scope.$index}`"  placement="top" :width="c.width+100">
						<div>
							<el-input
							size="mini"
							v-model="updatevalue"
						></el-input>
						</div>
						<div style="text-align: right;margin-top:5px">
							<el-button size="mini"  @click="Closepopover(scope)">取消</el-button> <el-button size="mini" type="primary" @click="UpdateCol(scope,scope.$index,c.field,c.evttype)">确认</el-button>
							</div>
							<el-link slot="reference" icon="el-icon-edit el-icon--right" @click="Openpopover(scope,scope.row[c.field])">{{ scope.row[c.field] }}</el-link>
					</el-popover>
				</div>
			</template>
		</pl-table-column>
		<pl-table-column v-for="(c, idx) in columns" v-if="c.type == 'template' && c.colshow != 0" :key="c.id" :label="c.title" :width="c.width" fixed="right">
			<template slot-scope="scope">
				<label v-for="(t, ix) in c.template" :key="ix" style="margin-left:15px">
					<el-link :type="t.handletype" :icon="t.icon" :underline="false" 
					@click="handle(t.event, scope.$index, scope.row, '', 'click', idx, t.l_id,t)">
						{{ t.title }}
					</el-link>
				</label>
			</template>
		</pl-table-column>
	</pl-table>
</template>
<script>
import XLSX from "xlsx";
import copy from "copy-to-clipboard";

// 右键菜单
const ContextMenu = function (options) {
  let instance;

  function createMenu() {
    const ul = document.createElement("ul");
    ul.classList.add("custom-context-menu");
    const { menus } = options;
    if (menus && menus.length > 0) {
      for (let menu of menus) {
        const li = document.createElement("li");
        li.textContent = menu.name;
        li.onclick = menu.onClick;
        li.classList.add(menu.class);
        ul.appendChild(li);
      }
    }
    const body = document.querySelector("body");
    body.appendChild(ul);
    return ul;
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createMenu();
      }
      return instance;
    },
    // 移除菜单
    removeMenu(){
      document.querySelector(".custom-context-menu")?.parentNode.removeChild(document.querySelector(".custom-context-menu")).remove
    }
  };
};

export default {
	props: {
		//列表数据
		tableData: {
			type: Array,
			default:function(){
				return [];
			}
		},
		//列表表头
		columns: {
			type: Array,
			default:function(){
				return [];
			}
		},
		//列表高度
		gridheight: {
			type: String,
			defualt: ''
		},
		gridwidth: {
			type: String,
			defualt: '0px'
		},
		editcell: {
			type: String,
			default: '0'
		},
		istop: {
			type: Boolean,
			default: false
		},
		rowclassname: {
			type: Function,
			default: () => () => {}
		},
		cellclassname: {
			type: Function,
			default: () => () => {}
		},
		stripe: {
			type: Boolean,
			default: true
		},
		isseq:{
			type: String,
			default: '1'
		},
		emptytext:{
			type: String,
			default: '没有查询到符合条件的记录'
		},
		isCopyRange:{
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			oldvalue: {}, //点击列表行时，当前选中行的值，可用于更改操作
			editcellvalue: 0,
			wllist: [],
			height:'',
			isadmin: 1,
			copyarray: [] ,//select筛选时临时保留的原数据
			airinfo:{},//空运信息
			aircolumns:[{title:'动态',field:'status',width:'280'},{title:'操作地点',field:'airport',width:'70'},{title:'件数',field:'pieces',width:'50'},{title:'重量',field:'weight',width:'70'},{title:'航班号',field:'flight',width:'90'},{title:'操作时间',field:'createtime',width:'130'}],
			airtitle:[],
			updatevalue:'',
			startDown: false,
			firstColumnIndex: null,
			endColumnIndex: null,
			firstRowIndex: null,
			endRowIndex: null,
			isHaveIndexColumn: true,
			columnProperties: [],
			// 菜单
			contextMenu: null,
			// 节流timer
			throttleTimer: null,
		};
	},
	created() {
		if(this.gridheight!=undefined)
			this.height = parseInt(this.gridheight.replace('px', ''));
		else 
			this.height='';	
		//debugger	
		console.log('iscopy-created',this.isCopyRange);	
	},
	mounted() {
		this.init();
		if(this.isCopyRange){
			// 菜单
			this.contextMenu = ContextMenu({
			  menus: [
			    {
			      name: "复制",
			      class: "copy-btn",
			      onClick: () => {
			        this.copyTable();
			      },
			    },
			  ],
			});
			// 鼠标按下
			window.addEventListener("mousedown", this.mousedownHandle);
			// 鼠标移动
			window.addEventListener("mousemove", this.throttleMouseMoveHandle);
			// 鼠标弹起
			window.addEventListener("mouseup", this.mouseUpHandle);
			
			document.addEventListener("contextmenu", this.showMenu);
			document.addEventListener("click", this.hideMenu);
			// 监听ctrl+c
			document.addEventListener("keydown", this.keydownHandle);
		}
		
	},
	beforeUnmount() {
		if(this.isCopyRange){
		  // 鼠标按下
		  window.removeEventListener("mousedown", this.mousedownHandle);
		  // 鼠标移动
		  window.removeEventListener("mousemove", this.throttleMouseMoveHandle);
		  // 鼠标弹起
		  window.removeEventListener("mouseup", this.mouseUpHandle);
		  document.removeEventListener("contextmenu", this.showMenu);
		  document.removeEventListener("click", this.hideMenu);
		  // 监听ctrl+c
		  document.removeEventListener("keydown", this.keydownHandle);
		  // 菜单 移除
		  this.contextmenu.removeMenu();
	  }
	},
	methods: {
		init(){
			//console.log('iscopy-init',this.isCopyRange);	
			var that=this;
			setTimeout(function(){
				that.columns.forEach(e=>{
					if(e.field!='')
						that.columnProperties.push(e.field);	
				});
				//console.log('可复制列-iscopy-init',that.isCopyRange);	
				//console.log('可复制列 '+JSON.stringify(that.columnProperties));
			},1500);
		},
		mouseUpHandle() {
		  this.startDown = false;
		},
		// 节流
		throttleMouseMoveHandle(event) {
		  this.throttleTimer = setTimeout(() => {
		    this.mouseMoveHandle(event);
		    clearTimeout(this.throttleTimer);
		    this.throttleTimer = null;
		  }, 100);
		},
		//mousemove
		mouseMoveHandle(event) {
		  // 按下并移动 
		  if (this.startDown) {
		    const obj = event.srcElement ? event.srcElement : event.target;
		    // td
			//console.log(obj);
		    const cellEle = obj.closest("td");
		    //不是表头
		    if (cellEle && !cellEle.closest("thead")) {
		      this.endColumnIndex = this.findColumnIndex(cellEle);
		      this.endRowIndex = this.findRowIndex(cellEle);
		      if (this.endColumnIndex > 0 && this.endRowIndex > 0) {
		        const tbody = cellEle
		          .closest(".select-table")
		          ?.querySelector("tbody");
		        if (tbody) {
		          for (let i = this.firstRowIndex; i <= this.endRowIndex; i++) {
		            const rowElem = tbody?.querySelectorAll(".el-table__row")[i];
		            if (rowElem) {
		              for (
		                let j = this.firstColumnIndex;
		                j <= this.endColumnIndex;
		                j++
		              ) {
		                rowElem
		                  .querySelectorAll("td")[j].classList.add("select-td-bg");
		              }
		            }
		          }
		        }
		      }
		    }
		  }
		},
		// mousedown
		mousedownHandle(event) {
		  // 左键
		  if (event.button === 0) {
		    // 是否是复制按钮
		    const obj = event.srcElement ? event.srcElement : event.target;
			//console.log(obj);
		    // 不是复制按钮
		    if (!obj.classList.contains("copy-btn")) {
		      // td
		      const cellEle = obj.closest("td");
		      //按下
		      if (cellEle) {
		        // 重置
		        this.resetSelectInfo();
		        this.startDown = true;
		        this.firstColumnIndex = this.findColumnIndex(cellEle);
		        this.firstRowIndex = this.findRowIndex(cellEle);
		      }
		    }
		  }
		},
		keydownHandle(e) {
		  // 监听复制 window &mac
		  if ((e.ctrlKey && e.keyCode === 67) || (e.metaKey && e.keyCode === 67)) {
		    this.copyTable();
		  }
		},
		// 复制菜单
		showMenu(event) {
		  // 存在网格才显示复制菜单
		  if (
		    this.firstColumnIndex !== null &&
		    this.endColumnIndex &&
		    this.firstColumnIndex >= 0 &&
		    this.endColumnIndex >= this.firstColumnIndex &&
		    this.firstRowIndex !== null &&
		    this.endRowIndex &&
		    this.firstRowIndex >= 0 &&
		    this.endRowIndex >= this.firstRowIndex
		  ) {
		    event.preventDefault();
		    const menus = this.contextMenu.getInstance();
		    menus.style.top = `${event.clientY}px`;
		    menus.style.left = `${event.clientX}px`;
		    menus.classList.remove("hidden");
		  }
		},
		// 隐藏菜单
		hideMenu() {
		  const menus = this.contextMenu.getInstance();
		  menus.classList.add("hidden");
		},
		copyTable() {
		  const list = [];
		  var colexists=false;
		  var colname='';
		  //debugger
		  if(this.firstColumnIndex==this.endColumnIndex&&this.firstRowIndex==this.endRowIndex)
		  {
			  if(this.columnProperties[this.firstColumnIndex]!=undefined)
				this.copyvalue(this.tableData[this.firstRowIndex][this.columnProperties[this.firstColumnIndex]]);
		  }else{
			  // 根据网格 生成数据
			  for (let i = this.firstRowIndex; i <= this.endRowIndex; i++) {
			  			//debugger
			    const item = this.tableData[i];
			    const rowList = [];
			    for (let j = this.firstColumnIndex; j <= this.endColumnIndex; j++) {
			  				rowList.push(item[this.columnProperties[j]]);
			    }
			    list.push(rowList);
			  }
			  //debugger
			  const ws = XLSX.utils.aoa_to_sheet(list);
			  const wb = XLSX.utils.book_new();
			  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
			  //debugger
			  const str = XLSX.write(wb, { type: "string", bookType: "html" });
			  copy(str, {
			    format: "text/html",
			  });
			  this.$message({
			    message: "复制成功",
			    type: "success",
			  });
			  this.resetSelectInfo();
		  }
		  
		},
		// 列index
		findColumnIndex(currentElement) {
		  // 获取父元素
		  const parentElement = currentElement.parentElement;
		  if (parentElement) {
		    const children = parentElement.children;
		    if (parentElement.children) {
		      // 查找当前元素在子元素列表中的索引位置
		      const index = Array.prototype.indexOf.call(children, currentElement);
		      //console.log("列index", index);
		      return index;
		    }
		    return null;
		  }
		  return null;
		},
		// 行index
		findRowIndex(currentElement) {
		  const row = currentElement.closest(".el-table__row");
		  if (row && row.parentElement) {
		    const children = row.parentElement.children;
		    const index = Array.prototype.indexOf.call(children, row);
		    //console.log("行index", index);
		    return index;
		  }
		  return null;
		},
		// 删除背景色
		resetSelectTd(tableEle) {
		  const rowLen = tableEle.children.length;
		  for (let i = 0; i < rowLen; i++) {
		    const rowElem = tableEle.querySelectorAll(".el-table__row")[i];
		    const columnLen = rowElem.children.length;
		    for (let j = 0; j < columnLen; j++) {
		      rowElem
		        .querySelectorAll("td")[j].classList.remove("select-td-bg");
		    }
		  }
		},
		//重置
		resetSelectInfo() {
		  this.firstColumnIndex = null;
		  this.endColumnIndex = null;
		  this.firstRowIndex = null;
		  this.endRowIndex = null;
		  if(this.$refs.tablegrid!=undefined){
			  const tbody = this.$refs.tablegrid.$el.querySelector("tbody");
			  if (tbody) {
			    this.resetSelectTd(tbody);
			  }
		  }
		},
		 
		settimevalue(rowindex,col,fileid){
			//debugger
			var that =this
			that.tableData[rowindex][fileid] = col[fileid];
			that.$forceUpdate();
		},
		//获取操作前的原值存放到变量
		setoldvalue(value, col) {
			this.oldvalue = JSON.parse(JSON.stringify(value));
			if (col != undefined) {
				if (col.source != undefined) {
					if (this.copyarray.length == 0) this.copyarray = col.source;
				}
			}
		},
		//操作列按钮事件
		//event--事件  index--行索引  row-列对象  field--列数据字段名  currentevent--触发此方法的事件名，比如change,blur  colindex-列索引  l_id--是模板列时，按钮权限id(跟业务相关)
		handle(event, index, row, field, currentevent, colindex, l_id,colattr) {
			var isevent = false;
			if((this.columns[parseInt(colindex)].type=='time'||this.columns[parseInt(colindex)].type=='date')&&currentevent!='change'){//&&this.columns[parseInt(colindex)].evttype==undefined
				this.gridkeyupinput({keyCode:13},colindex,index);
			}
			else{
				if ((currentevent == this.columns[parseInt(colindex)].evttype)||currentevent=='click') {
					isevent = true;
				}
				if(currentevent=='change'){
					this.$emit('gridchange', {colindex:colindex,row:row,index: index,
					event: event,
					field: field,
					l_id: l_id,
					colattr:colattr,validate:this.columns[parseInt(colindex)].validate});
				}
				if (isevent) {
					this.$emit('gridhandle', {
						event: event,
						index: index,
						row: row,
						field: field,
						l_id: l_id,
						colindex:colindex,
						oldvalue: this.oldvalue,
						colattr:colattr
					});
				}
			}
		},
		//列表排序，调用后端方法排序
		gridsortchange(column) {
			debugger
			if (column.order != null) {
				this.$emit('gridsort', {
					column: column
				});
			}
		},
		//复选框勾选/取消勾选操作
		handleSelectionChange(rows) {},
		//单行勾选事件，全选或者全部取消时不触发此事件
		onTableSelect(rows, row) {
			//debugger
			let selected = rows.length && rows.indexOf(row) !== -1;
			if (selected == 0) {
				selected = false;
			}
			this.$emit('checkboxchange', {
				row: row,
				rows: rows,
				selected: selected,
				selectedall: rows.length == this.tableData.length
			});
		},
		// //全选/取消全选
		selectall(rows) {
			//console.log('table', this.tableData);
			if (rows.length == 0 || rows.length == this.tableData.length) {
				//当全选或者全部取消时触发
				this.$emit('checkboxchange', {
					row: [],
					rows: [],
					selected: 0,
					selectedall: rows.length == this.tableData.length
				});
			}
		},
		//单元格单击事件
		// cellclick(row, column, event) {
		// 	this.$emit('cellclick', {
		// 		column: column,
		// 		row: row
		// 	});
		// },
		showevent(row, col, type) {
			// console.log('显示悬浮',row);
			// console.log('显示列',col);
			var that = this;
			that.wllist = [];
			if (row[col.field] != '') {
				//this.$tool.copyJSON(row[col.field]);
				if (type == 1) {
					var paraminfo = {
						handtype: 1,
						orderid: row.p_pkval
					};
					this.$apipost.get.getwl({ paraminfo: paraminfo }).then(res => {
						if(res.orderlist!=undefined){
							if(res.orderlist.length>0){
								if (res.orderlist[0].list != undefined) {
									that.wllist =res.orderlist[0].list;
								}
								if (that.wllist.length == 0) {
									that.wllist = [{ time: '', context: '暂无物流' }];
								}
							}
						}
					});
				}
				//直接按快递单号查物流
				if (type == 2) {
					this.$apipost.get.Getwaybill_GN({ expressid: row.expressid, expresscode:row.expresscode}).then(res => {
						if (res.list != undefined) {
							that.wllist = res.list;
						}
						if (that.wllist.length == 0) {
							that.wllist = [{ time: '', context: '暂无物流' }];
						}
					});
				}
				if(type==3){//按提单号查询物流
					this.airinfo={};
					this.airtitle=[];
					this.$apipost.get.GetAirway({ airwaybill: row.p_airwaybill}).then(res => {
						//console.log('空运结果',res);
						that.airinfo=res;
						that.airtitle.push(JSON.parse(JSON.stringify(res)));
					});
				}
				//查物流不结转订单
				if (type ==4) {
					var paraminfo = {
						handtype: 1,
						orderid: row.p_pkval,
						isupdate:0
					};
					this.$apipost.get.getwl({ paraminfo: paraminfo }).then(res => {
						if(res.orderlist!=undefined){
							if(res.orderlist.length>0){
								if (res.orderlist[0].list != undefined) {
									that.wllist =res.orderlist[0].list;
								}
								if (that.wllist.length == 0) {
									that.wllist = [{ time: '', context: '暂无物流' }];
								}
							}
						}
					});
				}
			}
		},
		gridscroll(e, event) {
			this.$emit('gridscroll', {
				e: e,
				event: event
			});
		},
		openurl(column, row) {
			this.$emit('cellclick', {
				column: column,
				row: row,
				event: 'openurl'
			});
		},
		rowdblclick(row, column, event) {
			this.$emit('rowdblclick', {
				column: column,
				row: row
			});
		},
		//下拉框筛选
		selectFilter(val, col) {
			if(col.oldsource==undefined)
				col.oldsource=JSON.parse(JSON.stringify(col.source));
			col.source = JSON.parse(JSON.stringify(col.oldsource));
			if (val) {
				var filter = col.source.filter(item => {
					return item.label.toLowerCase().indexOf(val) > -1 || item.value.toLowerCase().indexOf(val) > -1;
				});
				if(filter.length>0){
					col.source = filter;
				}else{
					this.$emit('selectFilter', {
						col: col,
						val:val
					});
				}
			}
		},
		gridkeyupinput(event, colindex, rowindex) {
			//console.log('文本框改变');
			//debugger
			if(this.editcell=='0')
				return false;
			if(rowindex==0){
				if(event.keyCode == 38||event.keyCode == 37){
					this.setuparrow();
				}
			}
			//|| event.keyCode == 38  || event.keyCode == 40
			if (event.keyCode == 13 || event.keyCode == 37  || event.keyCode == 39) {
				//得到当前操作列索引
				var cols = this.columns;
				//得到下一个可编辑列索引
				if (colindex > -1) {
					var nextindex = -1;
					var coltype = '';
					if (event.keyCode == 13|| event.keyCode == 39) {//回车 向右
						if(cols[colindex].evttype!=''&&cols[colindex].evttype!=undefined&&event.keyCode == 13){
							this.handle(this.columns[colindex].event, rowindex,this.tableData[rowindex],
							 this.columns[colindex].field, 'keyup', colindex,this.columns[colindex]);
						}
						else{
							colindex = colindex + 1;
							if (colindex== (cols.length-1)) {
								colindex = 0;
								rowindex = rowindex + 1;
							}
							for (var i = colindex; i < cols.length; i++) {
								if(cols[i]!=undefined){
									if (this.checkcoltype(cols[i])) {
										nextindex = i;
										coltype = cols[i].type;
										break;
									}
								}
								else{
									nextindex=colindex;
									break;
								}
							}
						}
					} else if (event.keyCode == 37) {//向左
						colindex = colindex - 1;
						if (colindex <= 0) {
							colindex = cols.length - 1;
							rowindex = rowindex - 1;
						}
						for (var i = colindex; i < cols.length; i--) {
							if(cols[i]!=undefined){
								if (this.checkcoltype(cols[i])) {
									nextindex = i;
									coltype = cols[i].type;
									break;
								}
							}else
							{
								nextindex=colindex;
								break;
							}
						}
					}
					if (nextindex > -1 && rowindex > -1) {
						if (rowindex < this.tableData.length) {
							if(this.$refs[coltype + '_' + nextindex + '_' +rowindex ]!=undefined)
								this.$refs[coltype + '_' + nextindex + '_' +rowindex ][0].focus();
						}
						else if(rowindex==this.tableData.length){
							this.autoaddrow(rowindex-1);
						}
					}
				}
			}
			this.$emit('gridchange', {colindex:colindex,row:this.tableData[rowindex],index: rowindex,
					event:this.columns[colindex].event,validate:this.columns[colindex].validate});
		},
		//自动添加行
		autoaddrow(rowindex){
			this.$emit('autoaddrow', {
				event: 'addrow',
				index:rowindex
			});
			var that=this;
			setTimeout(function() {
				that.setfoucsbyindex(rowindex,0, '',true);
			}, 200);
		},
		setuparrow(){
			this.$emit('setuparrow',{});
		},
		setgridfoucs(colindex,rowindex){
			if(this.tableData.length>0)
			{
				var cols = this.columns;
				if(colindex==undefined)
					colindex=0;
				if(rowindex==undefined)
					rowindex=0;
				for (var i = colindex; i < cols.length; i++) {
					if(cols[i]!=undefined){
						if (this.checkcoltype(cols[i])) {
							if(this.$refs[cols[i].type + '_' + i + '_'+rowindex]!=undefined)
								this.$refs[cols[i].type + '_' + i + '_'+rowindex][0].focus();
							break;
						}
					}
					else
						break;
				}
			}
		},
		//设置焦点到指定位置
		//rowindex--行索引  colindex--列索引   colname--列名
		setfoucsbyindex(rowindex,colindex,colname,isnext){
			if(isnext==undefined)
				isnext=false;
			if(colindex==undefined&&colname!=''){
				for(var i=0;i<this.columns.length;i++){
					if(this.columns[i].field==colname){
						colindex=i;
						break;
					}
				}
			}
			if(isnext)
			{
				for (var key in this.tableData[rowindex]){
					if(this.tableData[rowindex][key]!=''){
						rowindex++;
						break;
					}
				}
			}
			this.setgridfoucs(colindex,rowindex);
		},
		//检测列是否为可编辑列
		checkcoltype(col){
			return (col.colshow=='1'||col.colshow==undefined)&&(col.type == 'input' || col.type == 'select' || col.type == 'select_filter' || col.type == 'time'|| col.type == 'date')
		},
		//更新表字段
		UpdateCol(scope,rowindex,colname,keycol){
			//debugger
			var that=this;
			var tablename='',keyvalue='';
			if(this.tableData[rowindex].tablename!=undefined)
				tablename=this.tableData[rowindex].tablename;
			if(this.tableData[rowindex][keycol]!=undefined)
				keyvalue=this.tableData[rowindex][keycol];
			var paraminfo={
				tablename:tablename,
				colname:colname,
				colvalue:this.updatevalue,
				key:keycol,
				keyvalue:keyvalue
			}
			this.$apipost.post.UpdateGridCol({paraminfo:paraminfo}).then(res => {
				if(res.state=='1')
				{
					this.$tool.message('保存成功');
					that.tableData[rowindex][colname]=that.updatevalue;
					that.updatevalue='';
					that.Closepopover(scope);
				}
				else{
					this.$tool.message(res.message, 0);
				}
			});
		},
		Openpopover(scope,value){
			this.updatevalue=value;
			scope._self.$parent.$refs[`popover-${scope.$index}`][0].focus();
		},
		Closepopover(scope){
			scope._self.$parent.$refs[`popover-${scope.$index}`][0].doClose();
		},
		copyvalue(value){
			this.$tool.copyJSON(value);
		}
	}
};
</script>
<style>
.selectTr td {
	background: rgba(219, 223, 232, 0.2) !important;
	/* background: rgba(24, 155, 255, 0.2) !important;
	z-index:9999; */
}
.airmain {
	width: 80%;
	td {
		text-align: left;
		padding-left: 0px;
	}
}
.select-table {
  cursor: cell;
  user-select: none;
}

.select-table .el-table__body td.select-td-bg {
  /* background-color: #ecf5ff; */
	background-color:#aa0000;
}

.custom-context-menu {
  position: fixed;
  border: 1px solid #ccc;
  list-style: none;
  padding: 4px 0;
  border-radius: 4px;
  box-shadow: 0px 2px 6px 2px #ddd;
}

.custom-context-menu.hidden {
  display: none;
}

.custom-context-menu li {
  padding: 8px 12px;
  border-bottom: 1px solid #f0f2f5;
  user-select: none;
  transition: all 0.1s;
}

.custom-context-menu li:last-child {
  border-bottom: none;
}

.custom-context-menu li::hover {
  cursor: pointer;
  background-color: #0170fe;
  color: #fff;
}

.custom-context-menu li:active {
  background-color: #f0f2f7;
}
</style>
